<script setup>
    const { item } = defineProps(['item']);
</script>

<template>
    <div class="w-full form-group form-wrapper form-text-block">
        <img v-if="item.data.type ==='image'" :src="item.data.image_path" alt="Image" />
        <div v-if="item.data.type !=='image'" class="prose" v-html="item.data.content"></div>
    </div>
</template>

<style scoped>

</style>
